import React from 'react'
import styled from 'styled-components'
import Stripes from 'components/Stripes'
import PropTypes from 'prop-types'

export const StyledComponent = styled(({size, ...rest}) => {
  return (
    <div {...{...rest}}>
      <Stripes loading {...{size}} />
    </div>
  )
})`
 width: ${p => Math.floor(p.size * 28)}px;
 margin: ${p => Math.floor(p.size * 14)}px auto;

 ${p => p.css}
`
export const _LoadingStripes_StyledComponent = StyledComponent
const _LoadingStripes = ({size, slim, postwall_write_rights, ...rest}) => <StyledComponent {...{
  size: slim ? 1 : size,
  ...rest
}} />

_LoadingStripes.propTypes = {
  size: PropTypes.number
}
_LoadingStripes.defaultProps = {
  size: 2
}

export default _LoadingStripes

